import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import useStore from "../../hooks/store/useStore";
import Mask from "../../components/ui/Mask";
import Text from "../../components/ui/Text";
import generateTokenHK from "../../services/bookDemo/generateTokenHK";
import bookDemoFnHK from "../../services/bookDemo/bookDemoFnHK";
import Button from "./components/Button";
import RadioButton from "./components/RadioButton";
import { DayOptions } from "./constants";

export default function BookDemoHK() {
  const { t } = useTranslation();

  const { setShowBookDemoDrawer, setShowBookDemoThanks } = useStore(
    (state) => state.bookDemo,
  );
  const { userInformation } = useStore((state) => state.user);
  const { userName, phoneNumber } = userInformation || {};

  const [location, setLocation] = useState("");
  const [selectedDays, setSelectedDays] = useState<string[]>([]);

  const mutationForToken = useMutation({
    mutationFn: generateTokenHK,
    onSuccess: (data) => {
      mutationForSubmit.mutate(data.token);
    },
  });
  const mutationForSubmit = useMutation({
    mutationFn: bookDemoFnHK(userName, phoneNumber, location, selectedDays),
    onSuccess: () => {
      setShowBookDemoDrawer(false);
      setShowBookDemoThanks(true);
    },
  });
  const isLoading = mutationForSubmit.isLoading || mutationForToken.isLoading;

  const toggleDay = (val: string) => {
    setSelectedDays((prev) => {
      const next = prev.includes(val)
        ? prev.filter((v) => v !== val)
        : [...prev, val];

      return next.sort(
        (a, b) =>
          DayOptions.findIndex((o) => o.value === a) -
          DayOptions.findIndex((o) => o.value === b),
      );
    });
  };

  return (
    <div className="flex justify-center">
      <div className="flex w-full max-w-[310px] flex-col gap-10">
        <div>
          <Text className="text-xl">{t("bookDemoTitle")}</Text>

          <Text normal className="my-3">
            {userName + t("bookDemoDesc1")}
          </Text>
          <Text normal className="my-3">
            {t("bookDemoDesc2")}
          </Text>
        </div>

        <div className="flex flex-col gap-3">
          <Text lg className="font-medium">
            預約體驗地點
          </Text>

          <RadioButton
            text="荔枝角 D2 Place 寰宇家庭俱樂部"
            checked={location === "D2_Place"}
            onClick={() => setLocation("D2_Place")}
          />
          <RadioButton
            text="澳門活動教學中心"
            checked={location === "macau"}
            onClick={() => setLocation("macau")}
          />
        </div>

        <div className="flex flex-col gap-3">
          <Text lg className="font-medium">
            請選擇你的偏好的體驗日子 (可選多項)
          </Text>

          <div className="grid grid-cols-2 gap-3">
            {DayOptions.map(({ label, value }) => {
              return (
                <RadioButton
                  key={value}
                  text={label}
                  checked={selectedDays.includes(value)}
                  onClick={() => toggleDay(value)}
                />
              );
            })}
          </div>
        </div>

        <div className="sticky bottom-0 w-full bg-pink1 p-3">
          <Button
            text={t("bookDemoAction")}
            isLoading={isLoading}
            onClick={() => {
              mutationForToken.mutate();
            }}
            disabled={!location || selectedDays.length === 0}
          />
        </div>

        {isLoading ? <Mask /> : null}
      </div>
    </div>
  );
}
